import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuFind from '../../components/MenuFind';
import Filters from '../../components/Filters';
import CommunityResults from './CommunityResults';
import AreaInfo from './AreaInfo';

const styles = css`
  .FiltersComponent {
    @media (min-width: 992px) {
      display: none;
    }
  }
`;

const sortOptions = [
  { title: 'Name', field: 'name' },
  { title: 'City', field: 'address.addressLocality' },
  { title: 'State', field: 'address.addressRegion' },
  { title: 'Price Low To High', field: 'priceLow' },
  { title: 'Price High To Low', field: 'priceLow', dir: 'desc' },
];

class Communities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
      showMap: false,
    };
  }

  setSort = sort => {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  setShowMap = showMap => {
    this.setState({
      showMap,
    });
  }

  render() {
    const { area, page } = this.props;
    const { sort, showMap } = this.state;

    return (
      <PageWrapper className={styles}>
        <PageHelmet
          custom
          title={`New Home Communities in ${get(page, 'area_info[0].area_name')}`}
        >
          <meta name="description" content={`Browse new home communties from Woodbridge Communities in the ${get(page, 'area_info[0].area_name')} area.`} />
        </PageHelmet>
        <InsideHeader
          h1="Our Communities"
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuFind />
        <Filters
          type="communities"
          filterOptions={[
            {
              type: 'SingleSelect',
              filter: 'Area',
              title: 'City',
              placeholder: 'All Cities',
              routeParam: 'communityMarketArea',
            },
            {
              type: 'MultiSelect',
              filter: 'SchoolDistrict',
              title: 'School Districts',
              placeholder: 'All Districts',
            },
          ]}
          clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
          activeSort={sort}
          sortOptions={sortOptions}
          onSortSelect={this.setSort}
          showMap={showMap}
          onToggleMap={this.setShowMap}
        />
        <CommunityResults sort={sort} showMap={showMap} />
        <AreaInfo area={area} page={page} />
      </PageWrapper>
    );
  }
}

Communities.propTypes = {
  area: PropTypes.object,
  page: PropTypes.object.isRequired,
};

Communities.defaultProps = {
  area: undefined,
};

export default withData(
  {
    area: true,
    page: 'communities_list',
  },
  {
    required: {
      page: true,
    },
  },
)(Communities);



// WEBPACK FOOTER //
// ./src/pages/Communities/index.js